import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { AuditEntity, AuditLogWithUser, AuditOperation } from '@/typings/auditLog/auditLog';
import store from '@/store';
import { getAuditEntriesWithUsers } from '@/api/auditLog';
import { DateFormat, formatDate } from '@/utils/dates';
import RestoreTemplateVersion from '@/components/TemplateVersion/RestoreTemplateVersion.vue';
import { ProductVersionRestoredInfo } from '@/api/typings/product';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLog',
  props: {
    value: { type: Boolean },
    entityType: null,
    entityId: null,
    entityCreatedDate: null,
    displayName: null
  },
  emits: ["input", "close", "template-version-restored"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'close'): void;
    (event: 'template-version-restored', template: ProductVersionRestoredInfo): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    entityType: AuditEntity;
    entityId?: string | number;
    entityCreatedDate?: Date | string;
    displayName?: string;
};



const loading = ref(true);
const handlingTemplateVersions = ref(false);
const auditEntries = ref<AuditLogWithUser[]>([]);
const user = computed(() => store.state.user);



const closeModal = () => {
    handlingTemplateVersions.value = false;
    emit('close');
};

const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});

const templateVersionRestored = (template: ProductVersionRestoredInfo) => {
    emit('template-version-restored', template);
};

watch(
    () => props.entityId,
    () => {
        if (props.entityId && props.value) {
            getAuditEntriesWithUsers(props.entityType, `${props.entityId}`)
                .then(async (data) => {
                    if (!data.find((e) => e.operation == 'C') && props) {
                        data.unshift({
                            entity: props.entityType,
                            entityId: `${props.entityId}`,
                            operation: AuditOperation.CREATE,
                            performedByUserId: user.value!.Id,
                            date: new Date(props.entityCreatedDate!),
                            impersonatedUserId: null,
                            action: 'null',
                            details: null,
                            user: {
                                Name: store.state.user?.Name ?? '',
                                Username: store.state.user?.Username ?? '',
                                Email: '',
                                Canceled: false,
                                Disabled: false,
                                Validated: false,
                                Stores: []
                            }
                        });
                    }
                    auditEntries.value = data.reverse();
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                });
        }
    },
    { immediate: true }
);

const parseOperation = (operation: AuditOperation): string => {
    switch (operation) {
        case AuditOperation.CREATE:
            return 'Created';
        case AuditOperation.RESTORE:
            return 'Restored';
        case AuditOperation.UPDATE:
            return 'Updated';
        case AuditOperation.DELETE:
            return 'Deleted';
        default:
            return 'Unknown';
    }
};

const parseEntity = (entity: AuditEntity): string => {
    switch (entity) {
        case AuditEntity.LIBRARY:
            return 'Library';
        case AuditEntity.OPTION_SET:
            return 'Option Set';
        case AuditEntity.PRODUCT:
            return 'Product';
        case AuditEntity.TEMPLATE:
            return 'Template';
        case AuditEntity.DESIGN:
            return 'Design';
        default:
            return 'Unknown';
    }
};

const getTitle = (): string => {
    return handlingTemplateVersions.value ? 'Restore template version' : `${parseEntity(props.entityType)} history`;
};

const getFormattedDate = (date: Date): string => {
    return formatDate(date, DateFormat.MMMddYYYYTime);
};

const handleHistory = () => {
    handlingTemplateVersions.value = false;
};

const handleTemplateVersions = () => {
    handlingTemplateVersions.value = true;
};

return { __sfc: true,props, loading, handlingTemplateVersions, auditEntries, user, emit, closeModal, isOpen, templateVersionRestored, parseOperation, parseEntity, getTitle, getFormattedDate, handleHistory, handleTemplateVersions, RestoreTemplateVersion }
}

})